function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { CSSProperties, ElementType, FC, Ref, RefObject } from 'react';
import cn from 'classnames';
require("./Rating.css");
var styles = {
  "Rating": "Rating-module-Rating_2LC",
  "sSize": "Rating-module-sSize_2yq",
  "Star": "Rating-module-Star_BF2",
  "mSize": "Rating-module-mSize_3vQ",
  "lSize": "Rating-module-lSize_21k"
};
import { RatingStar } from './Star/RatingStar';
export const RatingSizes = {
  s: 's',
  m: 'm',
  l: 'l'
};
export const Rating = ({
  max = 5,
  filled = true,
  value,
  size = RatingSizes.m,
  className,
  style,
  innerRef,
  controlRef,
  tag: Component = 'div',
  ...props
}) => {
  value = Math.min(value, max);
  const stars = [];
  let preparedValue = filled ? Math.round(value) : value;
  for (let star = 1; star <= max; star++) {
    const fullness = preparedValue >= star ? 1 : Math.max(preparedValue - star + 1, 0);
    stars.push(fullness);
  }
  return /*#__PURE__*/React.createElement(Component, _extends({
    className: cn(styles.Rating, styles[`${size}Size`], className),
    style: style,
    ref: innerRef || controlRef,
    role: "img",
    "aria-label": `Рейтинг ${value} из ${max}`
  }, props), stars.map((fullness, key) => /*#__PURE__*/React.createElement(RatingStar, {
    key: key,
    fullness: fullness
  })));
};
if (process.env.NODE_ENV !== 'production') {
  Rating.displayName = 'Rating';
}